import type { TrainingStatus } from '@hcc/types';
import { useMobilisationsList } from '../../../hooks/useMobilisations';
import { useTrainingModules } from '../../../hooks/useTrainingModules';
import type { TrainingProgressFilter } from '../../../hooks/useTrainingProgress';

const selectClass =
  'rounded-token-sm border border-line-strong/20 bg-surface px-2 py-1.5 text-sm';

const STATUS_LABEL: Record<TrainingStatus, string> = {
  not_started: 'Not started',
  in_progress: 'In progress',
  passed: 'Passed',
};

/** Module / cohort / status filters, held in the page's search params. */
export function ProgressFilters({
  filter,
  onChange,
}: {
  filter: TrainingProgressFilter;
  onChange: (next: TrainingProgressFilter) => void;
}) {
  const modules = useTrainingModules();
  const mobilisations = useMobilisationsList();
  return (
    <div className="flex flex-wrap items-center gap-2 text-sm">
      <select
        aria-label="Filter by module"
        value={filter.module_id ?? ''}
        onChange={(e) => onChange({ ...filter, module_id: e.target.value || undefined })}
        className={selectClass}
      >
        <option value="">All modules</option>
        {(modules.data ?? [])
          .filter((m) => !m.archived_at)
          .map((m) => (
            <option key={m.id} value={m.id}>
              {m.title}
            </option>
          ))}
      </select>
      <select
        aria-label="Filter by mobilisation"
        value={filter.mobilisation_id ?? ''}
        onChange={(e) => onChange({ ...filter, mobilisation_id: e.target.value || undefined })}
        className={selectClass}
      >
        <option value="">Everyone</option>
        {(mobilisations.data ?? []).map((m) => (
          <option key={m.id} value={m.id}>
            {m.name}
          </option>
        ))}
      </select>
      <select
        aria-label="Filter by status"
        value={filter.status ?? ''}
        onChange={(e) =>
          onChange({ ...filter, status: (e.target.value || undefined) as TrainingStatus | undefined })
        }
        className={selectClass}
      >
        <option value="">Any status</option>
        {(Object.keys(STATUS_LABEL) as TrainingStatus[]).map((s) => (
          <option key={s} value={s}>
            {STATUS_LABEL[s]}
          </option>
        ))}
      </select>
    </div>
  );
}
